import { Route, Switch } from 'wouter'
import Login from '@/pages/login'
import { AuthContextProvider } from '@/context/authentication/auth-context'
import { ProjectProvider } from '@/context/projeto'
import { ForgotPassword } from '@/pages/forgot-password'
import SignUp from '@/pages/sign-up'
import Onboarding from '@/pages/onboarding'
import { ProjectRegistration } from '@/pages/project-registration'
import { TooltipProvider } from '@/components/ui/tooltip-primitive'
import { Toaster } from '@/components/ui/toaster'
import Dashboard from './pages/dashboard'
import { RelacaoPagamentosList, RelacaoPagamentosForm } from './pages/relacao-pagamentos'
import { TeamManagement } from './pages/team-management'
import { TaskManagement } from './pages/tasks'
import { Calendario } from './pages/calendario'
import { BankStatement } from './pages/bank-statement'
import GestaoRecursos from './pages/financeiro/gestao-recursos'
import GestaoRecursosEditar from './pages/financeiro/gestao-recursos-editar'
import GestaoRecursosDashboard from './pages/financeiro/gestao-recursos-dashboard'
import Orcamentos from './pages/financeiro/orcamentos'
import OrcamentosTabela from './pages/financeiro/orcamentos-tabela'
import Projetos from './pages/projetos'
import ProjetoDetails from './pages/projetos/[id]'
import Notificacoes from './pages/notificacoes'
import ConfiguracoesPage from './pages/configuracoes'
import DocumentosPage from './pages/documentos'
import EstimatePage from './pages/estimate'
import { ContratoList, ContratosForm } from './pages/contrato'
import { ContratoDetails } from './pages/contrato/views/contrato-details-view'
import { AuthGuard } from './routes/guards/auth-guard'
import PersonAddView from './pages/register-person'
import { DemonstrativoExtratoBancarioListView } from './pages/demonstrativo-extrato-bancario'
import { NotFound } from "@/pages/not-found"
import { GestaoEquipeList } from './pages/gestao-equipe'

function Router() {
  return (
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/criar-conta" component={SignUp} />
      <Route path="/esqueci-minha-senha" component={ForgotPassword} />
      <AuthGuard path="/onboarding" component={Onboarding} />
      <AuthGuard path="/cadastrar-pessoa" component={PersonAddView} />
      <AuthGuard path="/cadastrar-projeto" component={ProjectRegistration} />
      <AuthGuard path="/dashboard" component={Dashboard} />
      {/* Contratual */}
      <AuthGuard path="/contratual/gestao-equipe" component={TeamManagement} />
      <AuthGuard path="/contratual/contratos" component={ContratoList} />
      <AuthGuard path="/contratual/contratos/novo" component={() => <ContratosForm mode="add" />} />
      <AuthGuard path="/contratual/contratos/:id/editar" component={() => <ContratosForm mode="edit" />} />
      <AuthGuard path="/contratual/contratos/:id" component={ContratoDetails} />
      {/* Financeiro */}
      <AuthGuard path="/financeiro/relacao-pagamentos" component={RelacaoPagamentosList} />
      <AuthGuard path="/financeiro/relacao-pagamentos/novo" component={RelacaoPagamentosForm} />
      <AuthGuard path="/financeiro/demonstrativo" component={DemonstrativoExtratoBancarioListView} />
      <AuthGuard path="/financeiro/demonstrativo2" component={BankStatement} />
      <AuthGuard path="/financeiro/orcamentos/tabela" component={OrcamentosTabela} />
      <AuthGuard path="/financeiro/orcamentos" component={Orcamentos} />
      <AuthGuard path="/financeiro/orcamentos" component={EstimatePage} />
      <AuthGuard path="/financeiro/gestao-recursos/editar" component={GestaoRecursosEditar} />
      <AuthGuard path="/financeiro/gestao-recursos/dashboard" component={GestaoRecursosDashboard} />
      <AuthGuard path="/financeiro/gestao-recursos" component={GestaoRecursos} />
      {/* Documentacao */}
      <AuthGuard path="/documentacao/gestao-tarefas" component={TaskManagement} />
      <AuthGuard path="/documentacao/calendario" component={Calendario} />
      <AuthGuard path="/documentacao" component={DocumentosPage} />
      {/* Projetos */}
      <AuthGuard path="/projetos/:id" component={ProjetoDetails} />
      <AuthGuard path="/projetos" component={Projetos} />

      <AuthGuard path="/configuracoes" component={ConfiguracoesPage} />
      <AuthGuard path="/notificacoes" component={Notificacoes} />
      <AuthGuard path="/" component={Dashboard} />
      <Route component={NotFound} />
    </Switch>
  )
}

function App() {
  return (
    <TooltipProvider>
      <AuthContextProvider>
        <ProjectProvider>
          <Toaster />
          <Router />
        </ProjectProvider>
      </AuthContextProvider>
    </TooltipProvider>
  )
}

export default App
